import { render, staticRenderFns } from "./BufferDialog.vue?vue&type=template&id=2f80891c&scoped=true&"
import script from "./BufferDialog.vue?vue&type=script&lang=js&"
export * from "./BufferDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f80891c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2f80891c', component.options)
    } else {
      api.reload('2f80891c', component.options)
    }
    module.hot.accept("./BufferDialog.vue?vue&type=template&id=2f80891c&scoped=true&", function () {
      api.rerender('2f80891c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/contentbuffers/BufferDialog.vue"
export default component.exports